import GespreksklaarTool from './Tools/GespreksklaarTool';

export default function App() {
  return <GespreksklaarTool />;
}
